import ActiveSearchIcon from './component'

export default ActiveSearchIcon